<template>


    <div v-if="rtgId">
        <div>
            Einschätzung der Expert:innen zu den Themen:
        </div>
        <highcharts class="chart" ref="chart" :options="chartOptions"></highcharts>
    </div>

</template>

<script>
    import axios from "axios";
    import { Chart } from 'highcharts-vue';
    import HighchartsMore from 'highcharts/highcharts-more';
    import offlineExporting from "highcharts/modules/offline-exporting";
    import exporting from "highcharts/modules/exporting";
    import * as Highcharts from 'highcharts';

    HighchartsMore(Highcharts);
    offlineExporting(Highcharts)
    exporting(Highcharts)
    import {

    } from 'devextreme-vue/chart';
    const baseUri = "WebApi.asmx/api/statisticsService"
    export default {
        name: 'UserStats',
        components: {
            highcharts: Chart

        },
        data() {
            return {
                key: 0,
                dataSource: [],
                score: [],
                rtgId: 0,
                rawData: [],

                chartOptions: {
                    chart: {
                        renderTo: 'container',
                        size: '100%',
                        type: 'boxplot',
                        inverted: true,
                        backgroundColor: null,
                        style: {

                            fontFamily: 'var(--font-family)'
                        },
                    },
                    credits: {
                        enabled: false
                    },
                    title: {
                        text: ' ',

                        style: {
                            color: 'whitesmoke ',
                            fontSize: '15px'

                        }
                    },

                    legend: {
                        enabled: false
                    },

                    xAxis: {
                        categories: [],
                        title: {
                      
                                text: '<b class="labelPie">Frage</b>',
                                useHtml: true
                          
                          
                        },
                        labels: {
                             formatter: function () {
                                {
                                    return '<span class="labelPie">' + this.value + '</span>';
                                }
                            },

                            style: {
                                textOutline: false
                            },
                        }
                    },

                    yAxis: {
                        title: {
                            text: '<b class="labelPie">Bewertung</b>',
                            useHtml: true

                        },
                        gridLineColor: 'gray',
                       
                    },
                    plotOptions: {
                        boxplot: {
                            fillColor: 'rgba(1, 164, 194,0.5)',

                            stemColor: '#01a4c2',


                        },
                        opacity: 0.1,
                    },

                    series: [{
                        name: 'Bewertung',
                        data: [],
                        tooltip: {
                            headerFormat: '<em>{point.key}</em><br/>'
                        },
                        color: '#9cf0ff ',
                    }],
                    exporting: {

                        buttons: {

                            contextButton: {

                                enabled: false,
                                menuItems: ['downloadPNG', 'downloadSVG', 'downloadPDF', 'viewFullscreen', 'printChart']
                            }
                        },
                        exportButton: {
                            text: '<i class="fa fa-download"></i> Download',
                            // Use only the download related menu items from the default context button

                        },
                        fallbackToExportServer: false
                    }

                }
            };
        },

        created() {
            window.addEventListener("rtgIdChanged", function () {
                var self = this;

                self.rtgId = window.State.getRtgId()


            }.bind(this), false)

            if (this.rtgId > 0) {
                this.loadData(this.rtgId)
            }

        },
        computed: {
            calculateGraf() {
                var self = this;
                var result = [];
            
                var categScore = [];
                var i = 0;
                var data = this.rawData.where(m => m.RatValid == true && m.TexVote == 1)
                    .groupBy(function (t) { return t.RtyCaption });
                data.forEach(function (t) {

                    categScore = [];
                    t.sort(function (xs, ys) {
                        return xs.Score - ys.Score;
                    });
                    t.map(function (s) {
                        categScore.push(s.Score);

                    });
                    result[i] = self.BoxplotCalculation(categScore);
                    i++;
                });

                return result;

            },

            grafCategories() {

                var result = [];
                var data = this.rawData.where(m => m.RatValid == true && m.TexVote == 1)
                    .groupBy(function (t) { return t.RtyCaption });
                data.forEach(function (t) {
                    result.push(t.key);

                });
                return result
            }


        },
        watch: {
            rtgId: function (newVal, oldVal) {

                if (oldVal != newVal) {
                    this.loadData(this.rtgId).then(res => {
                        this.rawData = res.data.data;
                    })




                }

            },
     
            rawData() {


            },
            calculateGraf() {
                var self = this;

                const chart = this.$refs["chart"].chart;
                self.chartOptions.series[0].data = self.calculateGraf;
                chart.redraw();

            },
            grafCategories() {
                var self = this;

                const chart = this.$refs["chart"].chart
                self.chartOptions.xAxis.categories = self.grafCategories;
                chart.redraw();

            },




        },
        methods: {
            BoxplotCalculation: function (arr) {
                
                var score = [];
                var m = 0;
                var arrLenght = arr.length;
                if (arrLenght > 2) {
                    score[0] = arr[0];
                    score[4] = arr[arrLenght - 1];
                    if (arrLenght % 2 == 0) {
                        m = arrLenght / 2;
                        score[2] = (arr[m] + arr[m - 1]) / 2;

                    }
                    else {
                        m = (arrLenght - 1) / 2;

                        score[2] = (arr[m]);
                    }

                    var q1 = (arrLenght + 1) / 4;
                    q1 = Math.floor(q1);

                    score[1] = arr[q1 - 1] + ((arr[q1] - arr[q1 - 1]) / 4);

                    var q2 = 3 * q1;

                    score[3] = arr[q2 - 1] + (3 * (arr[q2] - arr[q2 - 1]) / 4);

                }
                else if (arrLenght == 2) {
                    score[0] = arr[0];
                    score[4] = arr[1];
                    score[2] = (arr[1] + arr[0]) / 2;
                    score[1] = arr[0];
                    score[3] = arr[1];
                }
                else {
                    score[0] = arr[0];
                    score[4] = arr[0];
                    score[2] = arr[0];
                    score[1] = arr[0];
                    score[3] = arr[0];

                }

                return score;
            },
            loadData(rtgId) {


                return axios
                    .get(baseUri + '/VotingStats?RtgId=' + rtgId)



            },

        },

    }

</script>
<style scoped>
    .chtBox {
        background: #ffffff1a;
    }
    .bitv .labelPie {
        fill: black;
    }

    .labelPie {
        fill: whitesmoke;
        outline: none;
    }
</style>